import React, { ReactElement } from 'react';

import './tertiary-button.scss';
import SecondaryButton from '@common/secondary-button/secondary-button';
import TertiaryButtonChevron, {
    ChevronDirection,
} from '@common/tertiary-button/tertiary-button-chevron/tertiary-button-chevron';
import { LinkTargetValues } from '@constants';
import PlusSignIcon from '@common/plus-sign-icon/plus-sign-icon';

interface Props {
    brand?: string;
    labelText: string;
    link?: string;
    linkTarget?: LinkTargetValues;
    onClick?: () => void;
    ariaLabel?: string;
    internal: boolean;
    dataTestId?: string;
    chevronDirection?: ChevronDirection;
    plusSign?: boolean;
    fromOrderHistory?: boolean;
    fromOrderDetails?: boolean;
    state?: any;
    className?: string;
    buttonTabIndex?: number;
    iconColor?: string;
    printOrderDetailsIcon?: ReactElement;
    onKeyDown?: (event: React.KeyboardEvent<HTMLAnchorElement>) => void;
}
const TertiaryButton = (props: Props): ReactElement => {
    const isLincoln: boolean = props.brand === 'lincoln';
    const leftChevronIconColor: string =
        props.iconColor ?? (isLincoln ? '#324047' : '#0562d2');
    const iconColor: string =
        props.iconColor ?? (isLincoln ? '#485b65' : '#0562d2');

    const generateClassName = (): string => {
        let className = '';

        if (isLincoln) {
            className = 'fmc-text-button';

            if (props.fromOrderHistory || props.fromOrderDetails) {
                className = '';
            }
        }

        return className;
    };

    return (
        <>
            {props.labelText && (
                <div className="tertiary-button" data-testid="tertiary-button">
                    <SecondaryButton
                        className={`${generateClassName()} ${
                            props.className ?? ''
                        }`}
                        internal={props.internal}
                        onClick={props.onClick}
                        link={props.link}
                        linkTarget={props.linkTarget}
                        state={props.state}
                        buttonType={isLincoln ? 'chevron-left' : 'dark-left'}
                        aria-label={props.ariaLabel}
                        dataTestId={props.dataTestId}
                        buttonTabIndex={props.buttonTabIndex}
                        onKeyDown={props.onKeyDown}
                    >
                        {props.chevronDirection === 'left' && (
                            <TertiaryButtonChevron
                                direction={props.chevronDirection}
                                color={leftChevronIconColor}
                            />
                        )}
                        {props.printOrderDetailsIcon && (
                            <>{props.printOrderDetailsIcon}</>
                        )}
                        <span className="tertiary-button__label-text">
                            {props.labelText}
                        </span>
                        {props.chevronDirection === 'right' && (
                            <TertiaryButtonChevron
                                direction={props.chevronDirection}
                                color={iconColor}
                            />
                        )}
                        {props.plusSign && <PlusSignIcon color={iconColor} />}
                    </SecondaryButton>
                </div>
            )}
        </>
    );
};

export default TertiaryButton;
